import { PropertySpyItemDetail } from 'features/propertySpyResult/propertySpyItemDetail/ui/PropertySpyItemDetail/PropertySpyItemDetail'

export const PropertySpyItemDetailPage = (): JSX.Element => {
    return (
        <>
            <PropertySpyItemDetail />
        </>
    )
}